<template>
    <div class="google-box">
        <DoBetter :childModle='childModleData' id="googleweb" class="black"></DoBetter>
        <PPC class="black"></PPC>
        <FromBanner :msg='msg' class="white"></FromBanner>
    </div>
</template>
<script>
    import DoBetter from '@/components/main/contact/dobetter'//引入页面说明
    import PPC from '@/components/main/project/ppc'//引入业务说明
    import FromBanner from '@/components/base/frombanner'//引入联系我们的banner模块    
    export default {
        name: 'Google',
        data() {
            return {
                childModleData: {
                    center: '我们通过各种付费广告渠道，帮助我们的网站触达精准客户，建立数字营销的线上客户池。我们的投放付费包括:Google ads，Facebook Ads，LinkedIn Ads，Youtube Video Ads。针对外贸B2B企业，我们只投放精准的关键词，吸收精准客户群。',
                    title: '付费广告',
                },
                msg: {
                    caption: '诊断您的网站SEO布局和关键词布局定制海外营销计划',
                    botton: '联系我们',
                }
            }
        },
        components: {
            DoBetter,
            PPC,
            FromBanner
        }
    }
</script>
<style scoped>
    /* .DoBetter>>>.center-caption {
        display: none;
    } */
    .google-box>>>.DoBetter {
        margin-top: 189px;
    }

    .DoBetter>>>.center-box::before {
        content: 'accurate';
        text-transform: uppercase;
        font-size: 140px;
        font-weight: bold;
        color: rgba(241, 241, 241, 1);
        top: 120px;
        opacity: 0.4;
    }

    .DoBetter>>>.center-box {
        width: 61%;
        height: 990px;

    }

    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.text-center {
        max-width: 29%;
    }

    .DoBetter>>>.title-caption {
        font-size: 30px;
        font-weight: 400;
        line-height: 42px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 80px;
        position: relative;
    }

    .DoBetter>>>.title-caption::before {
        content: 'PPC Advertising';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        white-space: nowrap;
        color: rgba(36, 136, 248, 1);
        transform: translateY(-150%);
    }

    .DoBetter>>>.center-box::after {
        width: 85%;
        height: 640px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/launchpresso-qqaFqXKBMig-unsplash.jpg') no-repeat left;
        background-size: cover;
        top: 50%;
        right: -50%;
        transform: translateY(-50%);
        z-index: 3;
    }

    .DoBetter>>>.boxBord {
        display: block;
        position: absolute;
        width: 50%;
        height: 640px;
        border: 1px solid #707070;
        top: 50%;
        right: 0;
        transform: translate(-10%, -40%);
        z-index: 0;
    }

    .google-box>>>.DoBetter {
        padding-bottom: 0;
    }

    @media(max-width: 995px) {

        .DoBetter>>>.boxBord,
        .DoBetter>>>.animetionLine,
        .google-box>>>.DoBetter::before {
            display: none;
        }

        .google-box>>>.DoBetter {
            margin-top: 0;
        }

        .DoBetter>>>.center-box {
            width: 100%;
            height: auto;
            min-height: auto;
        }

        .DoBetter>>>.title-caption {
            font-size: 24px;
            font-weight: 400;
            line-height: 140%;
            color: rgba(51, 51, 51, 1);
            position: relative;
            margin-bottom: 0%;
            padding-left: 5%;
            padding-top: 5%;
        }

        .DoBetter>>>.text-center {
            max-width: 100%;
            padding: 5%;
        }
    }

    /* @media(max-width: 1023px) {
        .DoBetter>>>.center-box::after {
            display: none;
        }

        .DoBetter>>>.boxBord {
            display: none;
        }
        .DoBetter>>>.center-box {
        width: 100%;
        height: 1590px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/launchpresso-aFqXKBMig-unsplash.jpg') no-repeat center;
        background-size: cover;
        background-attachment: initial;
    }
    .DoBetter>>>.text-center {
        max-width: 100%;
        transform: translateY(0%);
        background-color: #fff;
    }
    .DoBetter>>>.title-caption {
        font-size: 75px;
        line-height: 140%;
        color: #000;
        margin-bottom: 0;
        margin-left: 72%;
    }

    .DoBetter>>>.title-caption::before {
        content: 'Custom website';
        display: block;
        text-transform: uppercase;
        position: absolute;
        top: 0;
        left: 0;
        font-size: 40px;
        font-weight: 400;
        line-height: 128%;
        white-space: nowrap;
        color:  rgba(36, 136, 248, 1);
        transform: translateY(-150%);
    }
    .frombanner-box {
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/22058393137661.5e5d5bc2cb339.jpg') no-repeat center;
        background-attachment: initial;
        background-size: cover;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/porject/google.vue